/* AUTUMN15 display only. Native Shopify discount links/checkout own application.
 * Verified Admin schedule26Sep2026. No cookies, analytics events or cart writes. */
(function () {
  'use strict';
  const START = Date.parse('2026-09-28T01:30:00+02:00');
  const END = Date.parse('2026-09-30T23:59:00+02:00');
  function offerState({search, now, subscription = false, context = 'product', variant = ''}) {
    if (new URLSearchParams(search).get('offer') !== 'autumn15' || !Number.isFinite(now) || now >= END) return 'hidden';
    if (now < START) return context === 'cart' ? 'hidden' : 'upcoming';
    if (context === 'cart') return 'active';
    if (subscription) return 'subscription';
    return variant ? 'active' : 'hidden';
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {offerState, START, END};
  if (typeof customElements === 'undefined' || customElements.get('cx-promo-offer')) return;
  customElements.define('cx-promo-offer', class extends HTMLElement {
    connectedCallback() {
      this.started = performance.now();
      this.serverTime = Number(this.dataset.now) * 1000;
      this.update = this.update.bind(this);
      this.form = document.querySelector('form.product-form');
      this.update();
      document.addEventListener('variant:changed', this.update);
      document.addEventListener('change', this.update);
      document.addEventListener('visibilitychange', this.update);
      window.addEventListener('popstate', this.update);
      // Hidden variant/plan fields can change programmatically after the native fetch.
      if (this.form) {
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.form, {subtree:true, childList:true, attributes:true, attributeFilter:['value','checked']});
      }
      this.timer = setInterval(this.update, 30000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('variant:changed', this.update);
      document.removeEventListener('change', this.update);
      document.removeEventListener('visibilitychange', this.update);
      window.removeEventListener('popstate', this.update);
    }
    update() {
      const id = this.form?.querySelector('input[name="id"]')?.value || '';
      const subscription = !!this.form?.querySelector('#auto-replenish:checked') || !!this.form?.querySelector('input[name="selling_plan"]')?.value;
      const prices = [...this.querySelectorAll('[data-offer-variant]')];
      const variant = prices.find(el => el.dataset.offerVariant === id);
      const state = offerState({search:location.search, now:this.serverTime + performance.now() - this.started,
        subscription, context:this.dataset.context, variant:variant ? id : ''});
      for (const el of this.querySelectorAll('[data-offer-state]')) el.hidden = el.dataset.offerState !== state;
      for (const el of prices) el.hidden = el !== variant;
      this.hidden = state === 'hidden';
      this.dataset.state = state;
    }
  });
})();
